import * as React from 'react';
import { Document, pdfjs, Page } from 'react-pdf';
import { Button, Spin } from '@nackle/paper';
// components
import Modal from 'shared/modal';
// api
import { apiGetPrivacyFile } from '../api';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${ pdfjs.version }/pdf.worker.js`;


export default class PDFViewer extends React.Component {
    state = {
        pdf: '',
        numPages: null,
        pageNumber: 1
    };
    constructor( props ) {
        super( props );
    }
    onLoadSuccess = ( { numPages } ) => {
        this.setState( { numPages } );
    };
    prevPage = () => this.setState( { pageNumber: this.state.pageNumber - 1 } );
    nextPage = () => this.setState( { pageNumber: this.state.pageNumber + 1 } );
    getPDF = async () => {
        if ( !this.state.pdf ) {
            if ( this.props.file.file ) {
                this.setState( { pdf: this.props.file.file } );
            } else if ( this.props.file.resource ) {
                const arrayBuffer = await apiGetPrivacyFile( this.props.file.resource ).then(
                    async response => await new Response( response ).arrayBuffer()
                );
                this.setState( { pdf: arrayBuffer } );
            }
        }
    };
    render() {
        const { file } = this.props;
        const { pageNumber, numPages } = this.state;
        return (
            <Modal
                modalOpener={ file.name }
                onOpen={ this.getPDF }
                genericId={ `modal-${ file.key }` }
                Nav={
                    <div className="pdf-nav" key="pdf-nav">
                        <Button disabled={ pageNumber === 1 } onClick={ this.prevPage }>
                            Prev
                        </Button>
                        <Button disabled={ pageNumber === numPages } onClick={ this.nextPage }>
                            Next
                        </Button>
                    </div>
                }
            >
                <div className="pdf-document-wrapper" key="pdf-document-wrapper">
                    <Document file={ this.state.pdf } onLoadSuccess={ this.onLoadSuccess }>
                        <Page
                            pageNumber={ this.state.pageNumber }
                            width={ 700 }
                            loading={ <Spin /> }
                            noData=""
                        />
                    </Document>
                </div>
            </Modal>
        );
    }
}
